// Mirrors backend CAPS defaults so the UI can hide actions the server would reject.
export const CAP_DEFAULTS = {
    edit_any_file: [],
    sign_off_manager: ["Partner", "Manager"],
    sign_off_partner: ["Partner"],
    change_allocation: ["Partner", "Manager", "Senior"],
    delete_review_notes: ["Partner"],
    review_note_override: ["Partner"],
    delete_engagement: ["Partner"],
    archive_engagement: ["Partner", "Manager"],
    unarchive_engagement: ["Partner", "Manager"],
    roll_forward: ["Partner", "Manager", "Senior", "Junior"],
    manage_users: ["Partner"],
};
const LOCKED = new Set(["sign_off_partner", "delete_engagement", "manage_users"]);

export function can(user, cap) {
    if (!user) return false;
    const def = (CAP_DEFAULTS[cap] || []).includes(user.role);
    if (LOCKED.has(cap)) return def;
    const ov = (user.permissions || {})[cap];
    return ov === undefined ? def : !!ov;
}
